import type { PromotionsSummaryLocationReport } from '../types';

export function generatePromotionsJSON({ data }: { data: PromotionsSummaryLocationReport[] }) {
  const csv = data.map((report) => ({
    eventName: report.eventName,
    eventStartDate: report.eventStartDate,
    eventEndDate: report.eventEndDate,
    eventDiscount: report.eventDiscount,
    eventDiscountPercentage: report.eventDiscountPercentage,
    eventUseCount: report.eventUseCount,
    orderCount: report.orderCount,
    orderNetSales: report.orderNetSales,
  }));

  return csv;
}
